import { Injectable } from "@angular/core";
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class AgedtasksService extends BaseService {

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) {
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }
  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastAgedTasks").subscribe(
      (data: any) => {
        console.log("broadcastAgedTasks", data);
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime && !widget.IfNoDataFound) {

          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
          let agedTasks: any = result[0];

          widget.chartOptions.xAxis.data = ['0-1 Hrs', '1-2 Hrs', '5-10 Hrs', '10-24 Hrs', 'Above 1 day'];
          this.addDataSeries(widget.chartOptions, [agedTasks.BTW_0_AND_1_HRS_CNT,
          agedTasks.BTW_1_AND_2_HRS_CNT,
          agedTasks.BTW_5_AND_10_HRS_CNT,
          agedTasks.BTW_10_AND_24_HRS_CNT,
          agedTasks.ABOVE_1_DAY_CNT
          ], 'Aged Tasks', 'bar')
          widget.errorMessage = null;
        }
      }
      widget.dataLoaded = true;
      this._commonService.lastUpdatedTime = lastUpdatedTime;
      },
      err => {
        console.log("listenFor broadcastAgedTasks error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/agedtasks.service.ts